import type { Staff as StaffRead } from "@/types/staff/api-types/staff-types";
import type { StaffAvailability } from "@/types/appointments/api-types/availability-types";
import type { Staff } from "@/types/appointments/calendar-types";

export function toCalendarStaff(
  staffItems: StaffRead[],
  availabilityStaff: StaffAvailability[] | undefined
): Staff[] {
  return staffItems.map((s) => {
    const match = availabilityStaff?.find((entry) => entry.staff_id === s.id);
    return {
      id: String(s.id),
      name: s.preferred_name || `${s.first_name} ${s.last_name}`,
      working_hours: match?.working_hours ?? [],
    };
  });
}
